import { render } from "./ContactUsConfirm.vue?vue&type=template&id=55b13932"
import script from "./ContactUsConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactUsConfirm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ContactUsConfirm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "55b13932"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('55b13932', __exports__)) {
    api.reload('55b13932', __exports__)
  }
  
  module.hot.accept("./ContactUsConfirm.vue?vue&type=template&id=55b13932", () => {
    api.rerender('55b13932', render)
  })

}


export default __exports__